import { initials, initialsColor } from '../lib/avatar';

/**
 * A member's picture, falling back to their initials on a colour derived from
 * their name — so a guild with no photos still looks like a guild rather than a
 * column of grey circles.
 */
export function Avatar({
  name,
  src,
  size = 34,
}: {
  name: string;
  src?: string | null;
  size?: number;
}) {
  const style: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    border: src ? 'none' : '1px solid var(--hairline)',
    fontFamily: 'var(--font-body)',
    fontSize: Math.round(size * 0.38),
    fontWeight: 600,
    letterSpacing: '0.02em',
    color: '#fff',
    // Transparent behind a real picture, so a cut-out avatar shows the row
    // through it rather than a grey disc.
    background: src ? 'transparent' : initialsColor(name),
    userSelect: 'none',
  };

  return (
    <span style={style} aria-hidden="true">
      {src ? (
        <img src={src} alt="" width={size} height={size} style={{ objectFit: 'cover' }} />
      ) : (
        initials(name)
      )}
    </span>
  );
}
